module.exports = __webpack_public_path__ + "img/file-lines.02782489.svg";